import { linea as viemLinea } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const linea = {
  displayName: 'Linea',
  runtime: 'evm',
  viemChain: viemLinea,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'linea' },
    qnStreams: {
      networkKey: 'linea-mainnet',
    },
    pimlico: { chainSlug: 'linea' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
